import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import UserTeamSettingsStore from "../store";

/**
 * Sets loading state for a mute schedule group / unmute schedule group toggle operation.
 * Used to prevent race conditions from rapid successive clicks on the same menu item.
 *
 * When isLoading=true, the menu item should be disabled to prevent additional clicks
 * until the current save operation completes (or fails).
 *
 * @param teamId - The team ID
 * @param scheduleGroupId - The schedule group ID
 * @param isLoading - true when save is in progress, false when idle
 */
const setToggleLoading = mutatorAction(
    "SET_TOGGLE_LOADING",
    (teamId: string, scheduleGroupId: string, isLoading: boolean) => {
        const store = UserTeamSettingsStore();

        // Ensure team has a loading state map
        if (!store.toggleLoadingByTeamAndGroup.has(teamId)) {
            store.toggleLoadingByTeamAndGroup.set(teamId, new ObservableMap<string, boolean>());
        }

        const loadingMap = store.toggleLoadingByTeamAndGroup.get(teamId);

        if (isLoading) {
            // Set loading state
            loadingMap.set(scheduleGroupId, true);
        } else {
            // Clear loading state (remove from map entirely to keep it clean)
            loadingMap.delete(scheduleGroupId);
        }
    }
);

export default setToggleLoading;
